import { AppContext } from './contexts';
import './app.scss';
import Layout from './Layout';
import { useState } from 'react';
import defaultLabels from './default-labels';
import dayjs from 'dayjs';
import {
  mergePortalLabels,
  registerPortalStringOverrideDevTools
} from './utilities/stringOverrideDevTools';

registerPortalStringOverrideDevTools();

function App() {
  const [labels, setLabels] = useState(() => mergePortalLabels(defaultLabels));
  const [allLabels, setAllLabels] = useState({});
  const [currentWeek, setCurrentWeek] = useState(0);
  const [currentMonth, setCurrentMonth] = useState(dayjs().startOf('month').format('YYYY-MM-DD'));
  const [appointmentData, setAppointmentData] = useState({});
  const [appointmentTime, setAppointmentTime] = useState({});
  const [appointmentDataLoading, setAppointmentDataLoading] = useState(true);
  const [isWorkOrderView, setIsWorkOrderView] = useState(false);
  const [needHelpLink, setNeedHelpLink] = useState('');
  const [languages, setLanguages] = useState({});
  const [tasks, setTasks] = useState([]);
  const [workOrder, setWorkOrder] = useState({});
  const [branding, setBranding] = useState({});
  const [token, setToken] = useState();
  const [uid, setUid] = useState();
  const [zones, setZones] = useState();
  const [smsConsentDetails, setSmsConsentDetails] = useState();
  const [is24hrTime, setIs24hrTime] = useState(false);
  const [dateTimeFormat, setDateTimeFormat] = useState('DD/MM/YYYY h:mm a');
  const [errorMessage, setErrorMessage] = useState();
  const [newLinkLoading, setNewLinkLoading] = useState(false);

  return (
    <AppContext.Provider
      value={{
        tasks,
        setTasks,
        workOrder,
        setWorkOrder,
        branding,
        setBranding,
        appointmentData,
        setAppointmentData,
        appointmentDataLoading,
        setAppointmentDataLoading,
        token,
        setToken,
        uid,
        setUid,
        labels,
        setLabels,
        allLabels,
        setAllLabels,
        zones,
        setZones,
        smsConsentDetails,
        setSmsConsentDetails,
        currentWeek,
        setCurrentWeek,
        currentMonth,
        setCurrentMonth,
        is24hrTime,
        setIs24hrTime,
        dateTimeFormat,
        setDateTimeFormat,
        errorMessage,
        setErrorMessage,
        appointmentTime,
        setAppointmentTime,
        newLinkLoading,
        setNewLinkLoading,
        isWorkOrderView,
        setIsWorkOrderView,
        needHelpLink,
        setNeedHelpLink,
        languages,
        setLanguages
      }}
    >
      <Layout />
    </AppContext.Provider>
  );
}

export default App;
